import { render } from "./llmDialogicFinalFeedback.vue?vue&type=template&id=16c08b34&scoped=true"
import script from "./llmDialogicFinalFeedback.vue?vue&type=script&lang=js"
export * from "./llmDialogicFinalFeedback.vue?vue&type=script&lang=js"

import "./llmDialogicFinalFeedback.vue?vue&type=style&index=0&id=16c08b34&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c08b34"]])

export default __exports__